// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  IpfilterIngressFilter,
  IpfilterIngressTrafficType,
  V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequest,
  V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequest,
} from '../models/index';
import {
  IpfilterIngressFilterFromJSON,
  IpfilterIngressFilterToJSON,
  IpfilterIngressTrafficTypeFromJSON,
  IpfilterIngressTrafficTypeToJSON,
  V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequestFromJSON,
  V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequestToJSON,
  V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequestFromJSON,
  V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequestToJSON,
} from '../models/index';

export interface V1IpFilterTrafficTypesOrchestraIngressConfigGetRequest {
  orchestra: string;
}

export interface V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigGetRequest {
  orchestra: string;
  tenantid: string;
  dbid: string;
}

export interface V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutOperationRequest {
  orchestra: string;
  tenantid: string;
  dbid: string;
  request: V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequest;
}

export interface V1IpFiltersOrchestraIngressConfigGetRequest {
  orchestra: string;
}

export interface V1IpFiltersOrchestraIngressConfigPutRequest {
  orchestra: string;
  ipFilter: IpfilterIngressFilter;
}

export interface V1IpFiltersOrchestraTenantidDbidIngressConfigDeleteRequest {
  orchestra: string;
  tenantid: string;
  dbid: string;
}

export interface V1IpFiltersOrchestraTenantidDbidIngressConfigGetRequest {
  orchestra: string;
  tenantid: string;
  dbid: string;
}

export interface V1IpFiltersOrchestraTenantidDbidMaxFilterCountDeleteRequest {
  orchestra: string;
  tenantid: string;
  dbid: string;
}

export interface V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutOperationRequest {
  orchestra: string;
  tenantid: string;
  dbid: string;
  request: V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequest;
}

/**
 *
 */
export class IPFiltersApi extends runtime.BaseAPI {
  /**
   * Get a list of IP filters traffic type for an orchestra
   * Get a list of IP filters traffic type for an orchestra
   */
  async v1IpFilterTrafficTypesOrchestraIngressConfigGetRaw(
    requestParameters: V1IpFilterTrafficTypesOrchestraIngressConfigGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<IpfilterIngressTrafficType>>> {
    if (requestParameters['orchestra'] == null) {
      throw new runtime.RequiredError(
        'orchestra',
        'Required parameter "orchestra" was null or undefined when calling v1IpFilterTrafficTypesOrchestraIngressConfigGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/ip-filter-traffic-types/{orchestra}/ingress-config`;
    urlPath = urlPath.replace(
      `{${'orchestra'}}`,
      encodeURIComponent(String(requestParameters['orchestra'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(IpfilterIngressTrafficTypeFromJSON),
    );
  }

  /**
   * Get a list of IP filters traffic type for an orchestra
   * Get a list of IP filters traffic type for an orchestra
   */
  async v1IpFilterTrafficTypesOrchestraIngressConfigGet(
    requestParameters: V1IpFilterTrafficTypesOrchestraIngressConfigGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<IpfilterIngressTrafficType>> {
    const response =
      await this.v1IpFilterTrafficTypesOrchestraIngressConfigGetRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Get an IP filter traffic type for an orchestra
   * Get an IP filter traffic type for an orchestra
   */
  async v1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigGetRaw(
    requestParameters: V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IpfilterIngressTrafficType>> {
    if (requestParameters['orchestra'] == null) {
      throw new runtime.RequiredError(
        'orchestra',
        'Required parameter "orchestra" was null or undefined when calling v1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigGet().',
      );
    }

    if (requestParameters['tenantid'] == null) {
      throw new runtime.RequiredError(
        'tenantid',
        'Required parameter "tenantid" was null or undefined when calling v1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigGet().',
      );
    }

    if (requestParameters['dbid'] == null) {
      throw new runtime.RequiredError(
        'dbid',
        'Required parameter "dbid" was null or undefined when calling v1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/ip-filter-traffic-types/{orchestra}/{tenantid}/{dbid}/ingress-config`;
    urlPath = urlPath.replace(
      `{${'orchestra'}}`,
      encodeURIComponent(String(requestParameters['orchestra'])),
    );
    urlPath = urlPath.replace(
      `{${'tenantid'}}`,
      encodeURIComponent(String(requestParameters['tenantid'])),
    );
    urlPath = urlPath.replace(
      `{${'dbid'}}`,
      encodeURIComponent(String(requestParameters['dbid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      IpfilterIngressTrafficTypeFromJSON(jsonValue),
    );
  }

  /**
   * Get an IP filter traffic type for an orchestra
   * Get an IP filter traffic type for an orchestra
   */
  async v1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigGet(
    requestParameters: V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IpfilterIngressTrafficType> {
    const response =
      await this.v1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigGetRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Update an IP filter traffic type for an orchestra. If tenantid/dbid don\'t match existing resource, creates a new entry.
   * Update an IP filter traffic type for an orchestra
   */
  async v1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRaw(
    requestParameters: V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IpfilterIngressTrafficType>> {
    if (requestParameters['orchestra'] == null) {
      throw new runtime.RequiredError(
        'orchestra',
        'Required parameter "orchestra" was null or undefined when calling v1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPut().',
      );
    }

    if (requestParameters['tenantid'] == null) {
      throw new runtime.RequiredError(
        'tenantid',
        'Required parameter "tenantid" was null or undefined when calling v1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPut().',
      );
    }

    if (requestParameters['dbid'] == null) {
      throw new runtime.RequiredError(
        'dbid',
        'Required parameter "dbid" was null or undefined when calling v1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPut().',
      );
    }

    if (requestParameters['request'] == null) {
      throw new runtime.RequiredError(
        'request',
        'Required parameter "request" was null or undefined when calling v1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/v1/ip-filter-traffic-types/{orchestra}/{tenantid}/{dbid}/ingress-config`;
    urlPath = urlPath.replace(
      `{${'orchestra'}}`,
      encodeURIComponent(String(requestParameters['orchestra'])),
    );
    urlPath = urlPath.replace(
      `{${'tenantid'}}`,
      encodeURIComponent(String(requestParameters['tenantid'])),
    );
    urlPath = urlPath.replace(
      `{${'dbid'}}`,
      encodeURIComponent(String(requestParameters['dbid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequestToJSON(
          requestParameters['request'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      IpfilterIngressTrafficTypeFromJSON(jsonValue),
    );
  }

  /**
   * Update an IP filter traffic type for an orchestra. If tenantid/dbid don\'t match existing resource, creates a new entry.
   * Update an IP filter traffic type for an orchestra
   */
  async v1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPut(
    requestParameters: V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IpfilterIngressTrafficType> {
    const response =
      await this.v1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Get a list of IP filters for an orchestra
   * Get a list of IP filters for an orchestra
   */
  async v1IpFiltersOrchestraIngressConfigGetRaw(
    requestParameters: V1IpFiltersOrchestraIngressConfigGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<IpfilterIngressFilter>>> {
    if (requestParameters['orchestra'] == null) {
      throw new runtime.RequiredError(
        'orchestra',
        'Required parameter "orchestra" was null or undefined when calling v1IpFiltersOrchestraIngressConfigGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/ip-filters/{orchestra}/ingress-config`;
    urlPath = urlPath.replace(
      `{${'orchestra'}}`,
      encodeURIComponent(String(requestParameters['orchestra'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(IpfilterIngressFilterFromJSON),
    );
  }

  /**
   * Get a list of IP filters for an orchestra
   * Get a list of IP filters for an orchestra
   */
  async v1IpFiltersOrchestraIngressConfigGet(
    requestParameters: V1IpFiltersOrchestraIngressConfigGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<IpfilterIngressFilter>> {
    const response = await this.v1IpFiltersOrchestraIngressConfigGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Update an IP filter for an orchestra. Note: maxFilterCount in the request body is ignored — use PUT/DELETE /v1/ip-filters/{orchestra}/{tenantid}/{dbid}/max-filter-count to mutate that field.
   * Update an IP filter for an orchestra
   */
  async v1IpFiltersOrchestraIngressConfigPutRaw(
    requestParameters: V1IpFiltersOrchestraIngressConfigPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IpfilterIngressFilter>> {
    if (requestParameters['orchestra'] == null) {
      throw new runtime.RequiredError(
        'orchestra',
        'Required parameter "orchestra" was null or undefined when calling v1IpFiltersOrchestraIngressConfigPut().',
      );
    }

    if (requestParameters['ipFilter'] == null) {
      throw new runtime.RequiredError(
        'ipFilter',
        'Required parameter "ipFilter" was null or undefined when calling v1IpFiltersOrchestraIngressConfigPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/v1/ip-filters/{orchestra}/ingress-config`;
    urlPath = urlPath.replace(
      `{${'orchestra'}}`,
      encodeURIComponent(String(requestParameters['orchestra'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: IpfilterIngressFilterToJSON(requestParameters['ipFilter']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      IpfilterIngressFilterFromJSON(jsonValue),
    );
  }

  /**
   * Update an IP filter for an orchestra. Note: maxFilterCount in the request body is ignored — use PUT/DELETE /v1/ip-filters/{orchestra}/{tenantid}/{dbid}/max-filter-count to mutate that field.
   * Update an IP filter for an orchestra
   */
  async v1IpFiltersOrchestraIngressConfigPut(
    requestParameters: V1IpFiltersOrchestraIngressConfigPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IpfilterIngressFilter> {
    const response = await this.v1IpFiltersOrchestraIngressConfigPutRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Delete an IP filter for an orchestra
   * Delete an IP filter for an orchestra
   */
  async v1IpFiltersOrchestraTenantidDbidIngressConfigDeleteRaw(
    requestParameters: V1IpFiltersOrchestraTenantidDbidIngressConfigDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['orchestra'] == null) {
      throw new runtime.RequiredError(
        'orchestra',
        'Required parameter "orchestra" was null or undefined when calling v1IpFiltersOrchestraTenantidDbidIngressConfigDelete().',
      );
    }

    if (requestParameters['tenantid'] == null) {
      throw new runtime.RequiredError(
        'tenantid',
        'Required parameter "tenantid" was null or undefined when calling v1IpFiltersOrchestraTenantidDbidIngressConfigDelete().',
      );
    }

    if (requestParameters['dbid'] == null) {
      throw new runtime.RequiredError(
        'dbid',
        'Required parameter "dbid" was null or undefined when calling v1IpFiltersOrchestraTenantidDbidIngressConfigDelete().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/ip-filters/{orchestra}/{tenantid}/{dbid}/ingress-config`;
    urlPath = urlPath.replace(
      `{${'orchestra'}}`,
      encodeURIComponent(String(requestParameters['orchestra'])),
    );
    urlPath = urlPath.replace(
      `{${'tenantid'}}`,
      encodeURIComponent(String(requestParameters['tenantid'])),
    );
    urlPath = urlPath.replace(
      `{${'dbid'}}`,
      encodeURIComponent(String(requestParameters['dbid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete an IP filter for an orchestra
   * Delete an IP filter for an orchestra
   */
  async v1IpFiltersOrchestraTenantidDbidIngressConfigDelete(
    requestParameters: V1IpFiltersOrchestraTenantidDbidIngressConfigDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v1IpFiltersOrchestraTenantidDbidIngressConfigDeleteRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   * Get an IP filter for an orchestra
   * Get an IP filter for an orchestra
   */
  async v1IpFiltersOrchestraTenantidDbidIngressConfigGetRaw(
    requestParameters: V1IpFiltersOrchestraTenantidDbidIngressConfigGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IpfilterIngressFilter>> {
    if (requestParameters['orchestra'] == null) {
      throw new runtime.RequiredError(
        'orchestra',
        'Required parameter "orchestra" was null or undefined when calling v1IpFiltersOrchestraTenantidDbidIngressConfigGet().',
      );
    }

    if (requestParameters['tenantid'] == null) {
      throw new runtime.RequiredError(
        'tenantid',
        'Required parameter "tenantid" was null or undefined when calling v1IpFiltersOrchestraTenantidDbidIngressConfigGet().',
      );
    }

    if (requestParameters['dbid'] == null) {
      throw new runtime.RequiredError(
        'dbid',
        'Required parameter "dbid" was null or undefined when calling v1IpFiltersOrchestraTenantidDbidIngressConfigGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/ip-filters/{orchestra}/{tenantid}/{dbid}/ingress-config`;
    urlPath = urlPath.replace(
      `{${'orchestra'}}`,
      encodeURIComponent(String(requestParameters['orchestra'])),
    );
    urlPath = urlPath.replace(
      `{${'tenantid'}}`,
      encodeURIComponent(String(requestParameters['tenantid'])),
    );
    urlPath = urlPath.replace(
      `{${'dbid'}}`,
      encodeURIComponent(String(requestParameters['dbid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      IpfilterIngressFilterFromJSON(jsonValue),
    );
  }

  /**
   * Get an IP filter for an orchestra
   * Get an IP filter for an orchestra
   */
  async v1IpFiltersOrchestraTenantidDbidIngressConfigGet(
    requestParameters: V1IpFiltersOrchestraTenantidDbidIngressConfigGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IpfilterIngressFilter> {
    const response =
      await this.v1IpFiltersOrchestraTenantidDbidIngressConfigGetRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Remove spec.ipFilters.maxFilterCount, falling back to the global MAX_NUMBER_OF_IP_FILTERS limit. Idempotent.
   * Clear the max filter count for an IP filter
   */
  async v1IpFiltersOrchestraTenantidDbidMaxFilterCountDeleteRaw(
    requestParameters: V1IpFiltersOrchestraTenantidDbidMaxFilterCountDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IpfilterIngressFilter>> {
    if (requestParameters['orchestra'] == null) {
      throw new runtime.RequiredError(
        'orchestra',
        'Required parameter "orchestra" was null or undefined when calling v1IpFiltersOrchestraTenantidDbidMaxFilterCountDelete().',
      );
    }

    if (requestParameters['tenantid'] == null) {
      throw new runtime.RequiredError(
        'tenantid',
        'Required parameter "tenantid" was null or undefined when calling v1IpFiltersOrchestraTenantidDbidMaxFilterCountDelete().',
      );
    }

    if (requestParameters['dbid'] == null) {
      throw new runtime.RequiredError(
        'dbid',
        'Required parameter "dbid" was null or undefined when calling v1IpFiltersOrchestraTenantidDbidMaxFilterCountDelete().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/ip-filters/{orchestra}/{tenantid}/{dbid}/max-filter-count`;
    urlPath = urlPath.replace(
      `{${'orchestra'}}`,
      encodeURIComponent(String(requestParameters['orchestra'])),
    );
    urlPath = urlPath.replace(
      `{${'tenantid'}}`,
      encodeURIComponent(String(requestParameters['tenantid'])),
    );
    urlPath = urlPath.replace(
      `{${'dbid'}}`,
      encodeURIComponent(String(requestParameters['dbid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      IpfilterIngressFilterFromJSON(jsonValue),
    );
  }

  /**
   * Remove spec.ipFilters.maxFilterCount, falling back to the global MAX_NUMBER_OF_IP_FILTERS limit. Idempotent.
   * Clear the max filter count for an IP filter
   */
  async v1IpFiltersOrchestraTenantidDbidMaxFilterCountDelete(
    requestParameters: V1IpFiltersOrchestraTenantidDbidMaxFilterCountDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IpfilterIngressFilter> {
    const response =
      await this.v1IpFiltersOrchestraTenantidDbidMaxFilterCountDeleteRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Set spec.ipFilters.maxFilterCount on the IP filter resource. This is the only endpoint that mutates the limit; PUT /ingress-config leaves it untouched.
   * Set the max filter count for an IP filter
   */
  async v1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRaw(
    requestParameters: V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IpfilterIngressFilter>> {
    if (requestParameters['orchestra'] == null) {
      throw new runtime.RequiredError(
        'orchestra',
        'Required parameter "orchestra" was null or undefined when calling v1IpFiltersOrchestraTenantidDbidMaxFilterCountPut().',
      );
    }

    if (requestParameters['tenantid'] == null) {
      throw new runtime.RequiredError(
        'tenantid',
        'Required parameter "tenantid" was null or undefined when calling v1IpFiltersOrchestraTenantidDbidMaxFilterCountPut().',
      );
    }

    if (requestParameters['dbid'] == null) {
      throw new runtime.RequiredError(
        'dbid',
        'Required parameter "dbid" was null or undefined when calling v1IpFiltersOrchestraTenantidDbidMaxFilterCountPut().',
      );
    }

    if (requestParameters['request'] == null) {
      throw new runtime.RequiredError(
        'request',
        'Required parameter "request" was null or undefined when calling v1IpFiltersOrchestraTenantidDbidMaxFilterCountPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/v1/ip-filters/{orchestra}/{tenantid}/{dbid}/max-filter-count`;
    urlPath = urlPath.replace(
      `{${'orchestra'}}`,
      encodeURIComponent(String(requestParameters['orchestra'])),
    );
    urlPath = urlPath.replace(
      `{${'tenantid'}}`,
      encodeURIComponent(String(requestParameters['tenantid'])),
    );
    urlPath = urlPath.replace(
      `{${'dbid'}}`,
      encodeURIComponent(String(requestParameters['dbid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequestToJSON(
          requestParameters['request'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      IpfilterIngressFilterFromJSON(jsonValue),
    );
  }

  /**
   * Set spec.ipFilters.maxFilterCount on the IP filter resource. This is the only endpoint that mutates the limit; PUT /ingress-config leaves it untouched.
   * Set the max filter count for an IP filter
   */
  async v1IpFiltersOrchestraTenantidDbidMaxFilterCountPut(
    requestParameters: V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IpfilterIngressFilter> {
    const response =
      await this.v1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }
}
